import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute('/(redirects)/testsites')({
  beforeLoad: () => {
    throw redirect({ to: '/testing-events', replace: true });
  },
})
